import { formatPhoneNumber } from 'platform/form-renderer/util';
import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import {
  getProfilePrefillEmail,
  getProfilePrefillPhone,
} from '../../utils/helpers';
import PrefillCard from '../FormFields/PrefillCard';

const CARD_TITLE = content['sponsor--prefill-contact-card-title'];
const PHONE_LABEL = content['sponsor--prefill-contact-phone-label'];
const EMAIL_LABEL = content['sponsor--prefill-contact-email-label'];

const SponsorContactInfoPrefillCard = ({ formData }) => (
  <PrefillCard title={CARD_TITLE} testId="sponsor-contact-info-prefill-card">
    <p className="vads-u-margin--0">
      {PHONE_LABEL}{' '}
      <span className="dd-privacy-hidden" data-dd-action-name={PHONE_LABEL}>
        {formatPhoneNumber(getProfilePrefillPhone(formData) ?? '')}
      </span>
    </p>
    <p className="vads-u-margin--0" style={{ overflowWrap: 'break-word' }}>
      {EMAIL_LABEL}{' '}
      <span className="dd-privacy-hidden" data-dd-action-name={EMAIL_LABEL}>
        {getProfilePrefillEmail(formData)}
      </span>
    </p>
  </PrefillCard>
);

SponsorContactInfoPrefillCard.propTypes = {
  formData: PropTypes.object,
};

export default SponsorContactInfoPrefillCard;
